<!-- Context Menu Template -->
<ng-template #appointmentContextMenu>
  <div
    class="bg-blur-overlay-white flex w-56 flex-col rounded-3xl border-[2px] border-text-white bg-background-card p-2 shadow-card"
    cdkMenu
  >
    <button
      class="typo-h5-medium flex h-8 items-center gap-2 rounded-lg p-2 text-left transition-colors outline-none hover:bg-background-light-blue"
      [ngClass]="{ 'pointer-events-none opacity-50': !areTreatmentsLoaded }"
      cdkMenuItem
      (click)="onSetComplete()"
      [disabled]="!areTreatmentsLoaded"
    >
      <svg-icon key="px-16-appt-comp" size="sm" class="flex-shrink-0 text-text-primary"></svg-icon>
      <span class="flex-grow">{{ 'schedule_context_set_complete' | translate }}</span>
    </button>

    <div class="mx-auto my-1 h-px w-[90%] bg-background-disabled"></div>

    <button
      class="typo-h5-medium flex h-8 items-center gap-2 rounded-lg p-2 text-left transition-colors outline-none hover:bg-background-light-blue"
      cdkMenuItem
      [cdkMenuTriggerFor]="statusSubmenu"
      [cdkMenuPosition]="[{ originX: 'end', originY: 'top', overlayX: 'start', overlayY: 'top', offsetX: 12, offsetY: -8 }]"
    >
      <svg-icon key="px-16-circle" size="sm" class="flex-shrink-0 text-text-primary"></svg-icon>
      <span class="flex-grow">{{ 'schedule_context_status' | translate }}</span>
      <svg-icon key="px-24-arrow-right-1" size="md" class="ml-auto text-text-tertiary"></svg-icon>
    </button>

    <button
      class="typo-h5-medium flex h-8 items-center gap-2 rounded-lg p-2 text-left transition-colors outline-none hover:bg-background-light-blue"
      cdkMenuItem
      (cdkMenuItemTriggered)="onEditAppointment()"
    >
      <svg-icon key="px-16-edit" size="sm" class="flex-shrink-0 text-text-primary"></svg-icon>
      <span class="flex-grow">{{ 'schedule_context_edit' | translate }}</span>
    </button>

    <button
      class="typo-h5-medium flex h-8 items-center gap-2 rounded-lg p-2 text-left text-states-red transition-colors outline-none hover:bg-background-light-blue"
      cdkMenuItem
      (cdkMenuItemTriggered)="onDeleteAppointment()"
    >
      <svg-icon key="px-16-delete" size="sm" class="flex-shrink-0 text-states-red"></svg-icon>
      <span class="flex-grow">{{ 'schedule_context_delete' | translate }}</span>
    </button>

    <div class="mx-auto my-1 h-px w-[90%] bg-background-disabled"></div>

    <a
      class="typo-h5-medium flex h-8 items-center gap-2 rounded-lg p-2 text-left transition-colors hover:bg-background-light-blue"
      cdkMenuItem
      [ffdDynamicRouterLink]="{
        routerLink: 'chartingOnSiteForPatient',
        params: [vm.siteId!, vm.patientId!]
      }"
      [ffdPushTagOnClick]="{
        event: TagEvent.ChartingOpened,
        location: 'schedule',
        patient_id: vm.patientId!
      }"
      [appQueryParams]="{ fromHome: true }"
    >
      <svg-icon key="px-24-chart" size="sm" class="flex-shrink-0 text-text-primary"></svg-icon>
      <span class="flex-grow">{{ 'schedule_context_chart' | translate }}</span>
    </a>

    <div class="mx-auto my-1 h-px w-[90%] bg-background-disabled"></div>

    <button
      class="typo-h5-medium flex h-8 items-center gap-2 rounded-lg p-2 text-left transition-colors outline-none hover:bg-background-light-blue"
      cdkMenuItem
      (cdkMenuItemTriggered)="onOpenHealthHistory()"
    >
      <svg-icon key="px-16-history" size="sm" class="flex-shrink-0 text-text-primary"></svg-icon>
      <span class="flex-grow">{{ 'schedule_context_health_history' | translate }}</span>
    </button>
  </div>
</ng-template>

<!-- Status Submenu Template -->
<ng-template #statusSubmenu>
  <div
    class="bg-blur-overlay-white flex flex-col gap-2 rounded-3xl border-[2px] border-text-white bg-background-card p-4 shadow-card"
    cdkMenu
  >
    @for (status of statusOptions; track status.id) {
      <button
        class="typo-h5-medium flex h-8 items-center gap-2 rounded-lg p-2 text-left transition-colors outline-none hover:bg-background-light-blue"
        cdkMenuItem
        (cdkMenuItemTriggered)="onChangeStatus(status.id)"
      >
        @if (status.statusColor) {
          <div
            class="flex max-h-[16px] flex-shrink-0 items-center gap-1 rounded px-2 py-1"
            [ngClass]="{
              'border-[1px] border-solid border-text-extra-light': getStatusBackgroundColor(status) === '#ffffff'
            }"
            [style.background-color]="getStatusBackgroundColor(status)"
            [style.color]="getStatusTextColor(status)"
          >
            <p class="typo-h8-bold whitespace-nowrap">
              {{ getStatusCode(status) }}
            </p>
          </div>
        }
        <h4
          class="typo-h4-thin flex-grow"
          [ngClass]="{
            'typo-h5-semibold': status.id === vm.statusId
          }"
        >
          {{ status.description }}
        </h4>

        @if (status.id === vm.statusId) {
          <div class="flex h-6 w-6 items-center justify-center rounded-full bg-other-dropdown-check">
            <svg-icon size="sm" key="px-16-check" class="text-secondary-green"></svg-icon>
          </div>
        }
      </button>
    }
  </div>
</ng-template>
